import List from "@/components/list";

import { otherTrainTableData, theoreticalStudyTableData, topicLectureTableData } from "./constant";

const Table = (args) => {
  const { listeners, props } = args;
  const deleteTopic = listeners["deleteTopic"] || function () { };

  const tableType = props.type;

  const Deal = ({ props: { vo, configs } }) => {
    const row = vo.row;
    const dealConf = configs;
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item.name} placement="top" v-permission={item.permission}>
            <i class={item.icon} onClick={() => {deleteTopic(row)}}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  let AccountTableConfig = []

  let tableData = {}
  switch (tableType) {
    case 1:
      tableData = topicLectureTableData
      break;
    case 2:
      tableData = theoreticalStudyTableData
      break;
    case 3:
      tableData = otherTrainTableData
      break;

  }
  AccountTableConfig = AccountTableConfig.concat(tableData.columns)
  AccountTableConfig.push({
    label: "操作",
    fixed: "right",
    width: "40",
    align: "left",
    render: (vo) => <Deal vo={vo} configs={tableData.operateConfig} />
  })

  return (
    <div>
      <List {...args} talbeCols={AccountTableConfig} />
    </div>
  );
};
export default Table;
